import { render, staticRenderFns } from "./CaseDetailHeader.vue?vue&type=template&id=0f31ad24&scoped=true&"
import script from "./CaseDetailHeader.vue?vue&type=script&lang=js&"
export * from "./CaseDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f31ad24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VDivider,VIcon})
